module.exports = __webpack_public_path__ + "circle.d6ebe027.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/circle.svg
// module id = nG0o
// module chunks = 0